import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=27fa2279&scoped=true&"
import script from "./LandingView.vue?vue&type=script&lang=js&"
export * from "./LandingView.vue?vue&type=script&lang=js&"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=27fa2279&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa2279",
  null
  
)

export default component.exports